let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jf6KM")).then(() => parcelRequire('19jHL'));